<template>
    <div class="chart-info">
		<div class="chart-info__left">
			<div class="chart-info__row">
				<div class="chart-info__title">Прогнозируемый доход в {{getMonth}} {{getYear}}</div>
				<div class="chart-info__data">
					<span class="color-gold chart-info__data">$ {{$moneyf(dataPrognosis.featureProfit,'')}}</span>
					<span class="color-gold chart-info__data">% {{$moneyf(dataPrognosis.featureProfitPercent)}}</span>
				</div>
			</div>
			<div class="chart-info__row">
				<div class="chart-info__title">Фактический доход</div>
				<div class="chart-info__data d-flex">
					<div class="chart-info__data">
						<dataWatcher :data="getCurrencyProfit.profitAbs" :units="'$'"
									 :styleIconGreen="styleIconGreenCurr"
									 :styleIconRed="styleIconRedCurr" />
					</div>
					<div class="chart-info__data">
						<dataWatcher :data="getCurrencyProfit.profitRel" :units="'%'"
									 :styleIconGreen="styleIconGreenCurr"
									 :styleIconRed="styleIconRedCurr" />
					</div>
				</div>
			</div>
			<div class="chart-info__row">
				<div class="chart-info__title">Вероятность</div>
				<div class="chart-info__data color-green">
					<span>% 96</span>
				</div>
			</div>
			<div class="chart-info__row">
				<div class="chart-info__title">% усп. сделок</div>
				<div class="chart-info__data color-green">
					<span>% {{getProfitPercentPositions}}</span>
				</div>
			</div>
			<div class="chart-info__row">
				<div class="chart-info__title">Точность прогноза</div>
				<div class="chart-info__data color-green">
					<dataWatcher :data="getPrecisionPrognosis" :units="'%'"
								 :styleIconGreen="styleIconGreenCurr"
								 :styleIconRed="styleIconRedCurr" />
				</div>
			</div>
		</div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import dataWatcher from '../../../ui-components/ui-data-watcher'
export default {
    components: {
        dataWatcher
    },
    props: {
        dataPrognosis:{default:0}
    },
    data() {
        return {
            month:['Январе','Феврале','Марте','Апреле','Мае','Июне','Июле','Августе','Сентябре','Октябре','Ноябре','Декабре'],
            styleIconRedCurr: {
                'font-size': '30px !important',
                width: '28px !important',
                'padding-right': '20px !important',
                'max-height':'18px',
                'margin-right': '12px',
                'margin-left': '-14px',
                'margin-top': '-13px',
                'display':'block'
            },
            styleIconGreenCurr: {
                'font-size': '30px !important',
                width: '28px !important',
                'padding-right': '20px !important',
                'max-height':'18px',
                'margin-right': '12px',
                'margin-left': '-14px',
                'display':'block'
            },
        }
    },
    computed: {
        ...mapGetters({
            getSummaryPositions: 'closSummary/getSummary',
            getStatisticsProfits: 'accountstat/getMonthProfitStrategy'
        }),
        getMonth() {
            if(this.dataPrognosis === 0)
                return 0
            return this.month[new Date(this.dataPrognosis.lastDay.Date).getMonth()]
        },
        getYear() {
            if(this.dataPrognosis === 0)
                return 0
            return new Date(this.dataPrognosis.lastDay.Date).getFullYear()
        },
        getCurrencyProfit() {
            if(this.dataPrognosis === 0)
                return 0
            let profitAbs = this.dataPrognosis.lastDay.EquityClose - this.dataPrognosis.firstDay.EquityOpen
            let dataProfit = {
                    profitAbs:profitAbs,
                    profitRel:100/(this.dataPrognosis.firstDay.EquityOpen/profitAbs)
            }
            return dataProfit;
        },
        getProfitPercentPositions() {
            let allDeals = 0;
            let allProfitDeals = 0;
                for (let key in this.getSummaryPositions.SumBySymbol) {
                    allDeals+=this.getSummaryPositions.SumBySymbol[key].Count
                    allProfitDeals+=this.getSummaryPositions.SumBySymbol[key].CountProfit
                }
                let percent = 100/(allDeals/allProfitDeals);
                return Math.floor(percent);
        },
        getPrecisionPrognosis() {
            let stat = this.getStatisticsProfits('');
            if(!stat)
                return 0
            let sum = 0;
            for (let i = 0; i < stat.length; i++) {
                if(stat[i].profit > 0)
                    sum ++;
            }
            let profitMonth = 100/(stat.length/sum);
            return profitMonth;
        }
    },
}
</script>
<style lang="less" scoped>
.summaryData {
    &-item {
        display: flex;
    }
    &-itemTitle {
        font-family: Arimo;
        font-size: 12px;
        font-weight: 700;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.6;
        letter-spacing: .4px;
        color: #aabed2;
        text-transform: uppercase;
        margin-right: 12px;
        &-full {
            font-size:23px;
            line-height: 1;
            margin-bottom: 12px;
        }
        @media (max-width:1680px) {
            font-size: 10px;
        }
        @media (max-width:1400px) {
            font-size: 8px;
        }
    }
    &-itemData {
        font-family: Arimo;
        font-style: normal;
        font-weight: 700;
        font-stretch: normal;
        line-height: 1.27;
        letter-spacing: .4px;
        display: flex;
        color:#ecff24;
        span {
            margin-right: 8px;
        }
        &-full {
            font-size: 23px;
            line-height: 1;
        }
        @media (max-width:1650px) {
            font-size: 12px;
        }
    }
}
</style>
